import React, { useState } from 'react';
import { getForms } from '../../actions/formActions';
import { listUsers } from '../../actions/userActions';
import { useSelector, useDispatch } from 'react-redux';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';
import { FaPlus } from 'react-icons/fa'; // Importing the plus icon

const ManageUser = (props) => {
    const searchBoxKey = "user_search_form";
    const listFormKey = "user_list_form";
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const userState = useSelector((state) => state.user);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { listing = {} } = userState;
    const { data = {} } = searchBoxJson;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const addIconField = fields.filter(field => field.id == 'addIcon');
    const showAddIcon = addIconField.length > 0;
    const [{ label = '' } = {}] = addIconField;

    const actionsHandling = (action, rowData) => {
        console.log("Action = ", action, rowData);

    }

    const listApi = (data) => {
        return dispatch(listUsers(data, listFormKey));
    }

    const handleAdd = () => {
        alert('Yet to implement');
        setIsModalOpen(true);
    }

    return (
        <div style={{ position: 'relative', paddingBottom: showAddIcon ? '80px' : '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={listing}
                actionsHandling={actionsHandling}
            />

            {/* Floating Add Button */}
            {showAddIcon ? <div
                onClick={() => handleAdd()}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={label}
            >
                <FaPlus size={20} />
            </div> : ''}
        </div>
    );
}

export default ManageUser;
